import { convertEwsIdToRestId } from 'owa-identifiers';
import { ClientItem } from 'owa-mail-store';
import { lazyContextType, lazyGetNotesSDK } from 'owa-notes-store';
import getMailItemReadDeepLinkUrl from 'owa-url/lib/getMailItemReadDeepLinkUrl';

export interface ValidStickyNote {
    remoteId: string;
    id: string;
    color: string;
}

export default async function getValidStickyNote(
    isExistingUserNote: boolean,
    keyword: string,
    instance: number,
    item: ClientItem
): Promise<ValidStickyNote> {
    const getNotesSDK = await lazyGetNotesSDK.import();
    const contextType = await lazyContextType.import();
    await getNotesSDK()._ready;

    const getRemoteStickyNote = async (remoteId): Promise<ValidStickyNote> => {
        const remoteNote = await getNotesSDK().notesSDK?.getNote(remoteId);
        if (!remoteNote) {
            return null;
        }

        return {
            remoteId: remoteNote.remoteId,
            id: remoteNote.id,
            color: remoteNote.color,
        };
    };

    const createStickyNote = async (): Promise<ValidStickyNote> => {
        const webLinkId = convertEwsIdToRestId(item.ItemId.Id);
        return new Promise((resolve, reject) => {
            getNotesSDK().notesSDK?.createNote(
                undefined /* color */,
                undefined /* text */,
                undefined /* extension */,
                {
                    contextType: contextType.EMAIL,
                    id: webLinkId,
                    webLink: getMailItemReadDeepLinkUrl(item.ItemId.Id),
                    displayName: item.Subject,
                },
                remoteId => {
                    resolve(getRemoteStickyNote(remoteId));
                }
            );
        });
    };

    if (isExistingUserNote) {
        // Get existing sticky note
        const remoteId = getStickyNoteId(keyword, instance, item);
        return remoteId ? await getRemoteStickyNote(remoteId) : null;
    } else {
        // Create new sticky note
        return await createStickyNote();
    }
}

function getStickyNoteId(keyword: string, instance: number, item: ClientItem): string {
    for (const note of item.userNoteData) {
        if (keyword === note.keyword && instance === note.instance) {
            return note.stickyNoteId;
        }
    }
    return null;
}
